import { useState, useEffect } from 'react'

enum DeviceSize {
  Mobile,
  Tablet,
  Desktop,
  LargeDesktop,
}

function detectDeviceSize() {
  const width = window.innerWidth
  if (width < 768) {
    return DeviceSize.Mobile
  }

  if (width < 992) {
    return DeviceSize.Tablet
  }

  if (width < 1400) {
    return DeviceSize.Desktop
  }

  return DeviceSize.LargeDesktop
}

export default function useDeviceSize() {
  // Always start as Desktop (the value the server renders with) and detect
  // the real device size after mount, to avoid SSR hydration mismatches on
  // smaller screens (AI-25090)
  const [deviceType, setDeviceType] = useState<DeviceSize>(DeviceSize.Desktop)

  useEffect(() => {
    function handleResize() {
      setDeviceType(detectDeviceSize())
    }

    handleResize()

    window.addEventListener('resize', handleResize)

    return () => {
      window.removeEventListener('resize', handleResize)
    }
  }, [])

  return {
    isMobile: deviceType === DeviceSize.Mobile,
    isTablet: deviceType === DeviceSize.Tablet,
    isDesktop: deviceType === DeviceSize.Desktop,
    isLargeDesktop: deviceType === DeviceSize.LargeDesktop,
  }
}
